var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464 32h-416C21.49 32 0 53.49 0 80v352C0 458.5 21.49 480 48 480h416c26.51 0 48-21.49 48-48v-352C512 53.49 490.5 32 464 32zM48 464c-17.64 0-32-14.36-32-32v-51.31l106.3-106.3c3.125-3.125 8.188-3.125 11.31 0l79.03 79.03L102.1 464H48zM496 432c0 17.64-14.36 32-32 32H124.7l253.7-253.7c3.125-3.125 8.188-3.125 11.31 0L496 316.7V432zM496 294.1l-95.03-95.03c-9.375-9.344-24.56-9.344-33.94 0L224 342.1L144.1 263c-9.375-9.344-24.56-9.344-33.94 0L16 358.1V80c0-17.64 14.36-32 32-32h416c17.64 0 32 14.36 32 32V294.1zM128 104C97.07 104 72 129.1 72 160S97.07 216 128 216S184 190.9 184 160S158.9 104 128 104zM128 200C105.9 200 88 182.1 88 160c0-22.06 17.95-40 40-40S168 137.9 168 160C168 182.1 150.1 200 128 200z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageThin);
export default __webpack_public_path__ + "static/media/image_thin.84fc9b2a278491559444322bce9469ad.svg";
export { ForwardRef as ReactComponent };